import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';
import './styles/index.scss'
import 'react-medium-image-zoom/dist/styles.css'
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { store } from './redux/store';
// import { store } from './Rtk/Store'
import { Provider } from 'react-redux';

const container = document.getElementById('app');
const root = createRoot(container);
// import * as Sentry from "@sentry/react";

import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.REACT_APP_PUBLIC_SENTRY_DSN, // Replace with your DSN
    // integrations: [],
    // integrations: [Sentry.replayIntegration()], // Replace BrowserTracing with Replay
    // tracesSampleRate: 1.0, // Performance monitoring (keep it 0 if not needed)
    // replaysSessionSampleRate: 1.0, // Enable session replays
    environment: process.env.NODE_ENV !== 'development' ? process.env.NODE_ENV : ""
  });
}

root.render(
  <Sentry.ErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>
);